module.exports = __webpack_public_path__ + "img/trigger-white-crossicon.4a2d8152.svg";